/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";

import GetStartedAppModal from "./GetStartedAppModal";

const GetStartedAppModalContainer = ({
  setToggleModal,
  toggleModal
}) => {
  return (
    <GetStartedAppModal
      setToggleModal={setToggleModal}
      toggleModal={toggleModal}
    />
  );
};

export default GetStartedAppModalContainer;
